type Props = {
  fill?: string;
  height?: string;
  width?: string;
};
const SettingsIcon = ({
  fill = 'black',
  width = '24',
  height = '24'
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.73244 3C8.38663 2.4022 7.74028 2 7 2C6.25972 2 5.61337 2.4022 5.26756 3H3C2.44772 3 2 3.44772 2 4C2 4.55228 2.44772 5 3 5H5.26756C5.61337 5.5978 6.25972 6 7 6C7.74028 6 8.38663 5.5978 8.73244 5H21C21.5523 5 22 4.55228 22 4C22 3.44772 21.5523 3 21 3H8.73244ZM15.7324 11C15.3866 10.4022 14.7403 10 14 10C13.2597 10 12.6134 10.4022 12.2676 11H3C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13H12.2676C12.6134 13.5978 13.2597 14 14 14C14.7403 14 15.3866 13.5978 15.7324 13H21C21.5523 13 22 12.5523 22 12C22 11.4477 21.5523 11 21 11H15.7324ZM21 19H8.73244C8.38663 18.4022 7.74028 18 7 18C6.25972 18 5.61337 18.4022 5.26756 19H3C2.44772 19 2 19.4477 2 20C2 20.5523 2.44772 21 3 21H5.26756C5.61337 21.5978 6.25972 22 7 22C7.74028 22 8.38663 21.5978 8.73244 21H21C21.5523 21 22 20.5523 22 20C22 19.4477 21.5523 19 21 19Z"
        fill={fill}
      />
    </svg>
  );
};

export default SettingsIcon;
